module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-gutter": "16"
    }
  }, _vm._l((_vm.projects), function(project) {
    return _c('md-layout', {
      key: project.id,
      staticClass: "project-box-container",
      attrs: {
        "md-flex": "25"
      }
    }, [_c('dashboard-project-box', {
      attrs: {
        "project": project
      }
    })], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3141e045","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/dashboard/project-grid.vue
// module id = 644
// module chunks = 2